import type { UiState } from 'instantsearch.js';
import { useMemo } from 'react';
import { InstantSearchProps } from 'react-instantsearch';

import { useSearchClient } from '../../hooks/useSearchClient/useSearchClient.ts';
import { useSearchConfigMapper } from '../../hooks/useSearchConfigMapper/useSearchConfigMapper.ts';
import { RouteState, useSearchRouter } from '../../hooks/useSearchRouter/useSearchRouter.ts';
import { SearchConfigGetter } from '../../types/SearchConfigGetter.ts';

interface UseSearchConfigResult {
  searchConfigByDomain: SearchConfigGetter;
  instantSearchProps: InstantSearchProps<UiState, RouteState>;
}

export const useSearchConfig = (): UseSearchConfigResult => {
  const configMapper = useSearchConfigMapper();
  const { routing } = useSearchRouter(configMapper);
  const { searchClient } = useSearchClient({
    searchConfigByDomain: configMapper.searchConfigByDomain,
  });

  const { searchConfigByDomain } = configMapper;

  return useMemo<UseSearchConfigResult>(() => {
    return {
      searchConfigByDomain,
      instantSearchProps: {
        searchClient,
        future: { preserveSharedStateOnUnmount: true },
        routing,
      },
    };
  }, [searchConfigByDomain, searchClient, routing]);
};
